import React from 'react';
import PropTypes from 'prop-types';
import {SelectEntity} from '@ozgene/gp5.components.select-entity';
import {findAllImportedProjects} from 'Projects/service/ProjectService';

const findImportedProjects = async () => await findAllImportedProjects();

export default function SelectImportedProject(props) {
  const {value, onChange, label, ...restProps} = props;

  return (
    <SelectEntity
      getEntities={findImportedProjects}
      getOptionLabel={(value) => value.cnsObject?.name}
      value={value}
      onChange={onChange}
      label={label}
      {...restProps}
    />
  );
}

SelectImportedProject.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

SelectImportedProject.defaultProps = {
  value: null,
  label: 'Project',
};
